import React from "react";
import { compose, pick, map } from "ramda";
// import { makeStyles } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {
  useStoryblokEditable,
  StoryblokComponent
} from "@sb-konzept/gatsby-source-storyblok";

// import Grid from 'components/Grid'

function parsePrimitive(v) {
  try {
    return JSON.parse(v);
  } catch (_) {
    return v;
  }
}

export const cleanSizes = compose(
  map(v => (v === "" ? false : v)),
  map(parsePrimitive),
  pick(["xs", "sm", "md", "lg", "xl"])
);

function StoryblokGrid(props) {
  const { content } = props;
  const {
    alignContent,
    alignItems,
    direction,
    justify,
    gridSpacing,
    wrap,
    container,
    item,
    body,
    size
  } = content;
  const { editableProps } = useStoryblokEditable();

  if (size) {
    return (
      <div {...editableProps}>
        Your schema is out of sync! Please update your Sizes Field!{" "}
        <pre>{JSON.stringify(size, null, 2)}</pre>
      </div>
    );
  }

  const sizes = cleanSizes(content.sizes || {});

  const containerProps = {
    alignContent,
    alignItems,
    justify,
    spacing: Number(gridSpacing) || 0,
    wrap,
    direction
  };

  const itemProps = {
    ...sizes
  };

  return (
    <Grid
      container={container}
      item={item}
      {...container && containerProps}
      {...item && itemProps}
      {...editableProps}
    >
      {body.length ? (
        body.map(b => <StoryblokComponent key={b.id || b._uid} content={b} />)
      ) : (
        <Paper style={{ padding: 16, textAlign: "center" }}>hello</Paper>
      )}
    </Grid>
  );
}

export default StoryblokGrid;
